module.exports = __webpack_public_path__ + "media/bootstrap-icons/terminal-a7fbed66.svg";